// 統計分析モジュール ページ国際化
export default {
  // ── 共通 ──────────────────────────────────────────────
  'pages.analysis.enabled': '有効',
  'pages.analysis.disabled': '無効',
  'pages.analysis.total': '総レコード数',
  'pages.analysis.export': 'エクスポート',
  'pages.analysis.view': '表示',
  'pages.analysis.more': 'もっと見る',
  'pages.analysis.collapse': '折りたたむ',
  'pages.analysis.queryCondition': 'クエリ条件',
  'pages.analysis.filterCondition': 'フィルター条件',
  'pages.analysis.exportLoading': 'エクスポートデータを取得中、お待ちください…',
  'pages.analysis.exportFetchError': 'エクスポートデータの取得に失敗しました',
  'pages.analysis.exportNoData': 'エクスポートするデータがありません',
  'pages.analysis.exportSuccess': 'エクスポート成功',
  'pages.analysis.exportFailed': 'エクスポート失敗、再試行してください',
  'pages.analysis.generatedAt': '生成日時：',
  'pages.analysis.exportFailedSimple': 'エクスポート失敗',
  'pages.analysis.exportOptionExcel': 'Excel (.xlsx)',
  'pages.analysis.exportOptionCsv': 'CSV (.csv)',
  'pages.analysis.exportOptionPdf': 'PDF (.pdf)',
  'pages.analysis.range.to': '〜',
  'pages.analysis.range.from': '以降',
  'pages.analysis.range.all': 'すべて',
  'pages.analysis.search.placeholderKeyword': 'キーワードを入力（アカウント/ニックネーム/会社/部署）',
  'pages.analysis.search.placeholderUser': 'ユーザーアカウント/ニックネームを入力',
  'pages.analysis.search.placeholderUserAccount': 'ユーザーアカウントを入力',
  'pages.analysis.search.placeholderCompany': '会社を選択してください',
  'pages.analysis.search.placeholderDepartment': '部署を選択してください',
  'pages.analysis.search.placeholderCompanyInput': '所属会社を入力',
  'pages.analysis.search.placeholderDepartmentInput': '所属部署を入力',
  'pages.analysis.search.placeholderRole': 'ロールを選択してください',

  // ── 共通フィールドラベル ────────────────────────────────
  'pages.analysis.field.userId': 'ユーザーID',
  'pages.analysis.field.userAccount': 'アカウント',
  'pages.analysis.field.userNickname': '氏名',
  'pages.analysis.field.company': '所属会社',
  'pages.analysis.field.department': '所属部署',
  'pages.analysis.field.role': 'ロール',
  'pages.analysis.field.status': 'ステータス',
  'pages.analysis.field.createTime': '作成日時',
  'pages.analysis.field.updateTime': '最終更新日時',
  'pages.analysis.field.app': 'アプリ',
  'pages.analysis.field.appId': 'アプリID',
  'pages.analysis.field.appName': 'アプリ名',
  'pages.analysis.field.appType': 'アプリタイプ',
  'pages.analysis.field.appStatus': 'アプリステータス',
  'pages.analysis.field.appCreator': 'アプリ作成者',
  'pages.analysis.field.tokenUsed': 'トークン消費量',
  'pages.analysis.field.userCount': '利用者数',
  'pages.analysis.field.operation': '操作',
  'pages.analysis.field.unionQuery': '複合検索',
  'pages.analysis.field.user': 'ユーザー',
  'pages.analysis.field.terminal': '端末',
  'pages.analysis.field.accessTime': 'アクセス時間',
  'pages.analysis.field.terminalAdmin': '管理ポータル',
  'pages.analysis.field.terminalApp': 'アプリセンター',
  'pages.analysis.field.modelSource': 'モデルソース',
  'pages.analysis.field.inputTokens': '入力トークン',
  'pages.analysis.field.outputTokens': '出力トークン',
  'pages.analysis.field.rawTokens': '元トークン',
  'pages.analysis.field.tokenTotal': 'トークン総消費量',
  'pages.analysis.field.creator': '作成者',
  'pages.analysis.field.updater': '最終更新者',
  'pages.analysis.field.email': 'メールアドレス',
  'pages.analysis.field.featureTree': '機能ツリー',
  'pages.analysis.field.permCode': '権限コード',
  'pages.analysis.field.featurePerm': '機能権限',

  // ── アプリアクセス統計 (access/app) ──────────────────────
  'pages.analysis.accessApp.statusActive': '有効中',
  'pages.analysis.accessApp.statusInactive': '無効',
  'pages.analysis.accessApp.placeholderApp': 'アプリを選択してください',
  'pages.analysis.accessApp.reportTitle': 'アプリアクセス統計',

  // ── アプリアクセス詳細 (access/app/detail) ───────────────
  'pages.analysis.accessAppDetail.title': 'アプリアクセス詳細',
  'pages.analysis.accessAppDetail.useTime': '使用期間',
  'pages.analysis.accessAppDetail.appDesc': 'アプリ説明',
  'pages.analysis.accessAppDetail.appInfo': 'アプリ情報',
  'pages.analysis.accessAppDetail.accessLog': 'アクセスログ',

  // ── メニュー操作レポート (access/action) ─────────────────
  'pages.analysis.accessAction.actionId': '操作ID',
  'pages.analysis.accessAction.actionMenu': '操作メニュー',
  'pages.analysis.accessAction.type': '種別',
  'pages.analysis.accessAction.menuType': 'メニュー',
  'pages.analysis.accessAction.buttonType': 'ボタン',
  'pages.analysis.accessAction.operationTime': '操作時間',
  'pages.analysis.accessAction.actionRecord': '操作履歴',
  'pages.analysis.accessAction.reportTitle': 'メニュー操作レポート',

  // ── システムアクセスレポート (access/login) ──────────────
  'pages.analysis.accessLogin.account': 'アカウント',
  'pages.analysis.accessLogin.nickname': 'ニックネーム',
  'pages.analysis.accessLogin.company': '会社',
  'pages.analysis.accessLogin.loginDateTime': 'ログイン日時',
  'pages.analysis.accessLogin.logoutDateTime': 'ログアウト日時',
  'pages.analysis.accessLogin.loginIp': 'ログインIP',
  'pages.analysis.accessLogin.duration': '継続時間',
  'pages.analysis.accessLogin.loginSuccess': 'ログイン成功',
  'pages.analysis.accessLogin.loginFailed': 'ログイン失敗',
  'pages.analysis.accessLogin.loginTime': 'ログイン時間',
  'pages.analysis.accessLogin.logoutTime': 'ログアウト時間',
  'pages.analysis.accessLogin.loginRecord': 'ログイン履歴',
  'pages.analysis.accessLogin.reportTitle': 'システムアクセスレポート',
  'pages.analysis.accessLogin.minuteUnit': '分',
  'pages.analysis.accessLogin.chartDuration': 'アクセス時間（分）',

  // ── アプリアクセス権限レポート (audit/app) ──────────────
  'pages.analysis.auditApp.title': 'アプリアクセス権限レポート',
  'pages.analysis.auditApp.pleaseSelectApp': '先にアプリを選択してください',
  'pages.analysis.auditApp.permData': '権限データ',

  // ── ユーザー権限レポート (audit/user) ─────────────────────
  'pages.analysis.auditUser.title': 'ユーザー権限レポート',
  'pages.analysis.auditUser.pleaseSelectUser': 'ユーザーを選択してください',
  'pages.analysis.auditUser.queryFailed': 'クエリ失敗',
  'pages.analysis.auditUser.btnQuery': '閲覧',
  'pages.analysis.auditUser.btnEdit': '編集',
  'pages.analysis.auditUser.btnDelete': '削除',
  'pages.analysis.auditUser.btnAdd': '追加',
  'pages.analysis.auditUser.btnExport': 'エクスポート',
  'pages.analysis.auditUser.btnPrint': '印刷',
  'pages.analysis.auditUser.searchPlaceholder': 'メニュー名またはパスで検索',
  'pages.analysis.auditUser.userInfo': 'ユーザー情報',

  // ── ロール権限レポート (audit/role-assign) ───────────────
  'pages.analysis.auditRoleAssign.title': 'ロール権限レポート',
  'pages.analysis.auditRoleAssign.pleaseSelectRole': '先にロールを選択してください',
  'pages.analysis.auditRoleAssign.authData': '権限データ',

  // ── ロール権限詳細 (audit/role-detail) ───────────────────
  'pages.analysis.auditRoleDetail.title': 'ロール権限詳細',
  'pages.analysis.auditRoleDetail.loadRoleDetailFailed': 'ロール詳細の読み込みに失敗しました',
  'pages.analysis.auditRoleDetail.loadMenuPermFailed': 'メニュー権限の読み込みに失敗しました',
  'pages.analysis.auditRoleDetail.btnQuery': '表示',
  'pages.analysis.auditRoleDetail.btnEdit': '編集',
  'pages.analysis.auditRoleDetail.btnDelete': '削除',
  'pages.analysis.auditRoleDetail.btnAdd': '追加',
  'pages.analysis.auditRoleDetail.btnExport': 'エクスポート',
  'pages.analysis.auditRoleDetail.btnPrint': '印刷',
  'pages.analysis.auditRoleDetail.roleName': 'ロール名',
  'pages.analysis.auditRoleDetail.roleId': 'ロールID',
  'pages.analysis.auditRoleDetail.remark': '備考',
  'pages.analysis.auditRoleDetail.associatedCompany': '関連会社',
  'pages.analysis.auditRoleDetail.searchPlaceholder': 'メニュー名または権限コードで検索',
  'pages.analysis.auditRoleDetail.roleInfo': 'ロール情報',
  'pages.analysis.auditRoleDetail.pleaseSelectRole': 'ロールを選択してください',
};
